/**
 * Verti DEU PL API
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * Supported deductible values in euro.   (german: Selbstbeteiligung)
 */
export const Deductible = {
  _150: '150',
  _300: '300',
  _500: '500',
  _1000: '1000',
  _2000: '2000',
  _2500: '2500',
  _3000: '3000',
} as const;
export type Deductible = (typeof Deductible)[keyof typeof Deductible];
